import React from "react";
import PropTypes from "prop-types";

const PnLStatusChip = ({ status }) => (
  <span className={`pnl-chip ${status.kind}`} title={status.kind === "final" ? undefined : "Figures may change"}>
    {status.label}
  </span>
);

PnLStatusChip.propTypes = {
  status: PropTypes.shape({
    kind: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  }).isRequired,
};

export default PnLStatusChip;
